
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'; // Assuming Avatar is available

export const RecentActivityDashboardSection: React.FC = () => {
  // This is a placeholder. Actual data and list will be implemented later.
  const sampleActivities = [
    { id: 1, userInitials: 'RN', title: 'Meeting with Ryan Nuessle', description: 'Discussed Necker Cup proposal', time: '2 hours ago', type: 'meeting' },
    { id: 2, userInitials: 'CH', title: 'Email sent to Children\'s Hospital', description: 'Telecom expense management proposal', time: '4 hours ago', type: 'email' },
    { id: 3, userInitials: 'DS', title: 'Call with David Shapiro', description: 'Business development discussion', time: '1 day ago', type: 'call' },
    { id: 4, userInitials: 'MF', title: 'New contact added', description: 'Molly Fuller from Necker Cup', time: '2 days ago', type: 'contact' },
    { id: 5, userInitials: 'AD', title: 'Meeting with Atlanta Dental', description: 'Initial consultation completed', time: '3 days ago', type: 'meeting' },
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Recent Activity</CardTitle>
        <p className="text-sm text-muted-foreground">Latest updates and interactions</p>
      </CardHeader>
      <CardContent>
        <ul className="space-y-4">
          {sampleActivities.map(activity => (
            <li key={activity.id} className="flex items-start space-x-3">
              <Avatar className="h-9 w-9">
                <AvatarImage src={`https://avatar.vercel.sh/${activity.userInitials}.png`} alt={activity.userInitials} />
                <AvatarFallback>{activity.userInitials}</AvatarFallback>
              </Avatar>
              <div>
                <p className="text-sm font-medium">{activity.title}</p>
                <p className="text-xs text-muted-foreground">{activity.description}</p>
                <p className="text-xs text-muted-foreground mt-0.5">{activity.time}</p>
              </div>
            </li>
          ))}
        </ul>
        <p className="mt-4 text-center text-sm text-muted-foreground">
          Full Recent Activity feed functionality will be implemented next.
        </p>
      </CardContent>
    </Card>
  );
};

